<template>
    <div class="contents">
        <!-- The gallery's attrs come last, so its border color wins the class merge. -->
        <Button
            :label="$t('pages.product_detail_page.share.label')"
            :leading-icon="Share"
            class="border border-gray-300 bg-white text-black/60 hover:border-primary hover:text-primary"
            only-icon
            pill
            no-tooltip
            v-bind="$attrs"
            @click="isShareOpen = true"
        />
        <ShareModal
            v-model:open="isShareOpen"
            :title="$t('pages.product_detail_page.share.title')"
            content-type="product"
            :item-id="productStore.configurableProduct.group_identifier"
        >
            <ProductSharePreview />
        </ShareModal>
    </div>
</template>

<script setup lang="ts">
import Button from '@/components/buttons/Button.vue';
import ShareModal from '@/components/share/ShareModal.vue';
import ProductSharePreview from '@/pages/product-page/partials/product-image-gallery/partials/partials/ProductSharePreview.vue';
import { useProductStore } from '@/stores/products/ProductStore';
import { Share } from '@lucide/vue';
import { ref } from 'vue';

// The class and icon size from the gallery belong on the button, not on the wrapper.
defineOptions({ inheritAttrs: false });

const productStore = useProductStore();
const isShareOpen = ref(false);
</script>
